import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';

import { SharedEngagementsConstants } from '../../constants/shared-engagements.constants';

@Injectable({
	providedIn: 'root'
})
export class EngagementsHelperService {

	constructor(private contentSvc: ContentService) { }

	public getDefaultBpasEngagementCurrency(): string {
		return this.contentSvc.get('DEFAULT_BPAS_BASE_CURRENCY_SELECTION_OPTION', SharedEngagementsConstants.DEFAULT_BPAS_BASE_CURRENCY_SELECTION_OPTION);
	}
}
